import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { FileIcon } from '../../icons';

interface CarouselErrorBoundaryProps {
  children: React.ReactNode;
  fileName: string;
}

interface CarouselErrorBoundaryState {
  hasError: boolean;
}

/**
 * Error boundary for carousel renderers.
 * Catches rendering errors in child components and displays a fallback UI
 * instead of crashing the entire carousel.
 */
export class CarouselErrorBoundary extends React.Component<
  CarouselErrorBoundaryProps,
  CarouselErrorBoundaryState
> {
  constructor(props: CarouselErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): CarouselErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <View style={styles.container}>
          <FileIcon size={64} color="rgba(255,255,255,0.5)" />
          <Text style={styles.errorText}>Failed to display content</Text>
          <Text style={styles.fileName} numberOfLines={2}>
            {this.props.fileName}
          </Text>
        </View>
      );
    }

    return this.props.children;
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  errorText: {
    color: '#fff',
    fontSize: 16,
    marginTop: 16,
    marginBottom: 8,
  },
  fileName: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 13,
    textAlign: 'center',
  },
});
